import { FmApi } from '.'

import type { FollowListParams, FollowListResponse } from '~/features/center/follow/types'
import { PersonProfitParams, PersonProfitsInfo, PersonProfitsResponse } from '~/features/person/types'

export const CenterApi = FmApi.injectEndpoints({
  endpoints: (build) => ({
    // 素人收益记录
    getPersonProfits: build.query<PersonProfitsInfo, PersonProfitParams>({
      query: (params) => ({
        url: '/v2/user/liveincome',
        params: {
          start_date: params.start_date,
          end_date: params.end_date,
          p: params.p,
          type: params.type,
        },
        credentials: 'include',
      }),
      transformResponse: (res: PersonProfitsResponse) => {
        // data 的 item 中没有 id，需要加上
        const data =
          res?.data?.map((item, index) => ({
            ...item,
            // 增加时间戳，避免 id 重复
            id: `${item.confirm_time}${index}`,
          })) || []
        return { ...res, data }
      },
    }),
    getPersonTotalProfit: build.query<PersonProfitsInfo, PersonProfitParams>({
      query: (params) => ({
        url: '/v2/user/liveincome',
        // 接口仅在第一页返回 total 字段，所以需要单独分离出来
        params: { ...params, p: 1 },
      }),
      providesTags: ['GuildIncomeMenu'],
    }),
    getFollowList: build.query<FollowListResponse, FollowListParams>({
      query: (params) => ({
        url: '/v2/chatroom/follow/list',
        params,
        credentials: 'include',
      }),
    }),
  }),
}).endpoints
